import api from '../../ApiConfig';
import { Apis } from '../../config';


const getCartItems = async () => {
  try {
    var token = localStorage.getItem('userToken');
    let result = await api.get(Apis.GetAllCartItems, {
      headers: {
        'x-access-token': token
      }
    });
    if (result.data.error) {
      return null;
    }
    return result.data;

  } catch (error) {
    return null;
  }
};

const sendAbandonmentEmail = async (ids) => {
  try {
    var token = localStorage.getItem('userToken');
    let result = await api.post(Apis.SendAbandonmentEmail, ids,{
      headers: {
        'x-access-token': token
      }
    });
    // if (result.data.error) {
    //   return null;
    // }
    return result.data;

  } catch (error) {
    return null;
  }
};


const exportedObject = {
    getCartItems,
    sendAbandonmentEmail
};
export default exportedObject;